import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { PayoutsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createPayout = (data): any => action(types.CREATE_PAYOUT_REQUESTED, data);

export const updatePayout = (data): any => action(types.UPDATE_PAYOUT_REQUESTED, data);

export const deletePayout = (payoutId): any => action(types.DELETE_PAYOUT_REQUESTED, payoutId);

export const getPayout = (payoutId): any => action(types.GET_PAYOUT_REQUESTED, payoutId);

export const getAllPayouts = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_PAYOUTS_REQUESTED, { pagination, compile });

export const getAllPayoutsPayoutView = (
  pagination: IPagination = undefined,
  compile = true,
  teamCode = undefined,
  payoutCode = undefined,
): any => action(types.GET_ALL_PAYOUTS_REQUESTED, {
  pagination,
  compile,
  payoutView: true,
  teamCode,
  payoutCode,
});

export const selectPayout = (payoutId): any => action(types.SELECT_PAYOUT_REQUESTED, {
  currentPayoutId: payoutId,
});
export const clearPayouts = (): any => action(types.CLEAR_PAYOUTS);

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createPayoutPending: (payload): any => action(types.CREATE_PAYOUT_PENDING, payload),
  createPayoutSuccess: (response): any => action(types.CREATE_PAYOUT_SUCCESS, {
    payoutsById: response.entities.payouts,
    currentPayoutId: response.result,
  }),
  updatePayoutPending: (payload): any => action(types.UPDATE_PAYOUT_PENDING, payload),
  updatePayoutSuccess: (response): any => action(types.UPDATE_PAYOUT_SUCCESS, {
    payoutsById: response.entities.payouts,
    currentPayoutId: response.result,
  }),
  updatePayoutFailed: (error): any => action(types.UPDATE_PAYOUT_FAIL, { backendErrors: error }),
  deletePayoutPending: (response): any => action(types.DELETE_PAYOUT_PENDING, response),
  deletePayoutSuccess: (response): any => action(types.DELETE_PAYOUT_SUCCESS, {
    currentPayoutId: response,
  }),
  getPayoutPending: (): any => action(types.GET_PAYOUT_PENDING, {}),
  getPayoutSuccess: (response): any => action(types.GET_PAYOUT_SUCCESS, {
    payoutsById: response.entities.payouts,
    currentPayoutId: response.result,
  }),
  getPayoutFailed: (error): any => action(types.GET_PAYOUT_FAIL, { backendErrors: error }),
  deletePayoutFailed: (error): any => action(types.DELETE_PAYOUT_FAIL, { backendErrors: error }),
  getAllPayoutsPending: (pagination): any => action(types.GET_ALL_PAYOUTS_PENDING, { pagination }),
  getAllPayoutsSuccess: (response, meta): any => action(types.GET_ALL_PAYOUTS_SUCCESS, {
    payoutsById: response.entities.payouts,
    payoutIds: response.result,
    meta,
  }),
  getAllPayoutsFailed: (error): any => action(types.GET_ALL_PAYOUTS_FAIL, { backendErrors: error }),
  createPayoutFailed: (error): any => action(types.CREATE_PAYOUT_FAIL, { backendErrors: error }),
};

export default null;
